import { css } from 'styled-components'
import { ScreenSizes, MediaQueries } from './types'

const devicesSizes: ScreenSizes = {
  smallMobile: 400,
  mobile: 600,
  tablet: 900,
  laptop: 1280,
  desktop: 1440,
  bigDesktop: 1920,
}

export const media: MediaQueries = {
  smallMobile: (...args) => css`
    @media (max-width: ${devicesSizes.smallMobile}px) {
      ${css(...args)};
    }
  `,
  mobile: (...args) => css`
    @media (max-width: ${devicesSizes.mobile}px) {
      ${css(...args)};
    }
  `,
  tablet: (...args) => css`
    @media (max-width: ${devicesSizes.tablet}px) {
      ${css(...args)};
    }
  `,
  laptop: (...args) => css`
    @media (max-width: ${devicesSizes.laptop}px) {
      ${css(...args)};
    }
  `,
  desktop: (...args) => css`
    @media (max-width: ${devicesSizes.desktop}px) {
      ${css(...args)};
    }
  `,
  bigDesktop: (...args) => css`
    @media (max-width: ${devicesSizes.bigDesktop}px) {
      ${css(...args)};
    }
  `,
}

export const isDeviceAn = (deviceType: keyof ScreenSizes): boolean =>
  window.innerWidth <= devicesSizes[deviceType]
